import { configurationApi } from "~/api";
import { useCustomersQuery } from "~/apis/use-customers-query";
import { useWorkflowsQuery } from "~/apis/use-workflows-query";
import { transformListData } from "../api/lists.mappers";

export const useLists = () => {
  const workflowsQuery = useWorkflowsQuery();
  const customersQuery = useCustomersQuery();

  const listsQuery = configurationApi.useQuery("get", "/api/List", undefined, {
    meta: { errorTitle: "Failed to load lists" },
  });

  const listsData = (listsQuery.data ?? []).map((list) =>
    transformListData(list, workflowsQuery.data, customersQuery.data)
  );

  return {
    lists: listsData,
    isLoading: listsQuery.isLoading || workflowsQuery.isLoading || customersQuery.isLoading,
    isError: listsQuery.isError || workflowsQuery.isError || customersQuery.isError,
    allWorkflows: workflowsQuery.data,
    allCustomers: customersQuery.data,
    workflowsLoading: workflowsQuery.isLoading,
    customersLoading: customersQuery.isLoading,
  };
};
